import { FC } from 'react'
import { Tabs } from 'antd'
import shallow from 'zustand/shallow'

import { PyramidsTab } from './PyramidsTab'
import { PyramidType } from '../../types'
import { usePyramidsStore, PyramidTabs } from './PyramidsStore'

const { TabPane } = Tabs

export const PyramidsTabs: FC = () => {
  const [activeTab, isAgePyramidVisible] = usePyramidsStore((state) => [state.activeTab, state.isAgePyramidVisible], shallow)

  return (
    <Tabs activeKey={activeTab} renderTabBar={() => <></>}>
      <TabPane key={PyramidTabs.Level}>
        <PyramidsTab type={PyramidType.Level} />
      </TabPane>
      {isAgePyramidVisible && (
        <TabPane key={PyramidTabs.Age}>
          <PyramidsTab type={PyramidType.Age} />
        </TabPane>
      )}
    </Tabs>
  )
}
